import React from 'react';
import { MapPin, Navigation, Clock, ShieldCheck } from 'lucide-react';

const POINTS = [
  { icon: Navigation, text: 'Suivre votre trajet en temps réel pour le répartiteur' },
  { icon: Clock, text: "Estimer les heures d'arrivée aux clients" },
  { icon: MapPin, text: 'Enregistrer automatiquement vos arrêts et heures de travail' },
];

export const LocationDisclosure = ({ onAccept, onRefuse }) => (
  <div className="fixed inset-0 z-[9999] bg-slate-950 flex flex-col overflow-y-auto" data-testid="location-disclosure">
    <div className="flex-1 flex flex-col justify-center px-6 py-10 max-w-md mx-auto w-full">
      <div className="w-16 h-16 rounded-2xl bg-amber-500/15 border border-amber-500/40 flex items-center justify-center mb-6">
        <MapPin className="w-8 h-8 text-amber-400" />
      </div>
      <h1 className="text-2xl font-bold text-white mb-4" data-testid="location-disclosure-title">
        Utilisation de votre position
      </h1>
      <p className="text-base text-slate-200 leading-relaxed mb-5" data-testid="location-disclosure-text">
        <strong className="text-amber-300">ProPilote Driver collecte des données de localisation</strong> pour
        permettre les fonctions ci-dessous, <strong className="text-amber-300">même lorsque l'application est
        fermée ou n'est pas utilisée</strong>, pendant votre quart de travail.
      </p>
      <ul className="space-y-3 mb-6">
        {POINTS.map(({ icon: Icon, text }) => (
          <li key={text} className="flex items-start gap-3 text-sm text-slate-300">
            <Icon className="w-5 h-5 text-amber-400 shrink-0 mt-0.5" />
            <span>{text}</span>
          </li>
        ))}
      </ul>
      <div className="flex items-start gap-3 text-xs text-slate-400 bg-slate-900 border border-slate-800 rounded-xl p-3 mb-4">
        <ShieldCheck className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" />
        <span>
          Votre position est partagée uniquement avec votre employeur (répartition). Elle n'est jamais vendue
          ni utilisée à des fins publicitaires. Le suivi s'arrête à la déconnexion et peut être désactivé dans
          les paramètres.
        </span>
      </div>
      <p className="text-[11px] text-slate-500 leading-relaxed">
        ProPilote Driver collects location data to enable real-time trip tracking for your dispatcher,
        arrival time estimates and automatic stop logging, even when the app is closed or not in use.
      </p>
    </div>
    <div className="px-6 pb-8 pt-2 max-w-md mx-auto w-full space-y-3">
      <button
        onClick={onAccept}
        className="w-full py-3.5 rounded-xl bg-amber-500 hover:bg-amber-400 text-black font-bold text-base transition-colors"
        data-testid="location-disclosure-accept"
      >
        Accepter
      </button>
      <button
        onClick={onRefuse}
        className="w-full py-3 rounded-xl bg-slate-800 hover:bg-slate-700 text-slate-200 font-semibold text-sm transition-colors"
        data-testid="location-disclosure-refuse"
      >
        Refuser
      </button>
    </div>
  </div>
);

export const LocationRefusedBanner = ({ onEnable }) => (
  <div className="fixed bottom-20 left-3 right-3 z-[60] bg-slate-900 border border-amber-500/50 rounded-xl px-4 py-3 flex items-center justify-between gap-3 shadow-lg" data-testid="location-refused-banner">
    <span className="text-xs text-slate-200">Suivi de position désactivé</span>
    <button onClick={onEnable} className="text-xs font-bold text-amber-400 hover:text-amber-300" data-testid="location-refused-enable">
      Activer
    </button>
  </div>
);
